import { Injectable } from '@angular/core';

import { SearchConfigService } from '../../search-results/services/search-config.service';
import { ClassNames } from '../../shared/icon-font/icon-font-classes.utility';
import { IconFontType } from '../../shared/icon-font/icon-font-type.enum';
import { LocService } from '../../shared/shared-context/loc.service';

export interface AppModel {
    AppName: string;
    IconUnicodeCodepointCssClass: string;
    Referral: string;
    Title: string;
    Url: string;
}

@Injectable({
    providedIn: 'root'
})
export class CommercialApps {

    private commercialApps: Array<AppModel>;

    constructor(
        private readonly locService: LocService,
        private readonly searchConfigService: SearchConfigService
    ) {
    }

    public getCommercialAppList(): Array<AppModel> {
        return this.commercialApps;
    }

    public initializeCommericalAppList(appProviderApps: Array<Object>) {
        const commercialAllApps: Array<AppModel> = [
            {
                AppName: this.searchConfigService.config.resources.BrandVisio,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Visio),
                Referral: 'VisioOnline',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandVisio),
                Url: 'https://www.microsoft.com/microsoft-365/visio/flowchart-software'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandPowerBI,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.PowerBI),
                Referral: 'PowerBi',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandPowerBI),
                Url: 'https://powerbi.microsoft.com'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandPublisher,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Publisher),
                Referral: 'Publisher',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandPublisher),
                Url: 'https://www.microsoft.com/microsoft-365/publisher'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandAccess,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Access),
                Referral: 'Access',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandAccess),
                Url: 'https://www.microsoft.com/microsoft-365/access'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandSharePoint,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.SharePoint),
                Referral: 'SharePoint',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandSharePoint),
                Url: 'https://www.microsoft.com/microsoft-365/sharepoint/collaboration'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandHighLander,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.HighLander),
                Referral: 'HighLander',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandHighLander),
                Url: 'https://www.microsoft.com/microsoft-365/business/task-management-software'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandProject,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Project),
                Referral: 'Project',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandProject),
                Url: 'https://www.microsoft.com/microsoft-365/project/project-management-software'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandSkypeForBusiness,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.SkypeForBusiness),
                Referral: 'SkypeForBusiness',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandSkypeForBusiness),
                Url: 'https://www.microsoft.com/microsoft-365/skype-for-business/download-app'
            },
            {
                AppName: this.searchConfigService.config.resources.BrandStream,
                IconUnicodeCodepointCssClass: this.getBaseCSSClass() + ' ' + ClassNames.getCssClass(IconFontType.Stream),
                Referral: 'MicrosoftStream',
                Title: this.locService.format(this.searchConfigService.config.resources.SearchSuggestionGetAppForBusinessText, this.searchConfigService.config.resources.BrandStream),
                Url: 'https://www.microsoft.com/microsoft-365/microsoft-stream'
            }
        ];

        // Filtering out apps that are installed on users' machines.
        // Installed apps should not be shown in Go To provider.
        const filteredCommercialApps: Array<AppModel> = [];
        commercialAllApps.forEach(app => {
            let isAppInstalled = false;
            for (let i = 0; i < appProviderApps.length; i++ ) {
                if (appProviderApps[i]['Title'] && appProviderApps[i]['Title'] === app['Referral']) {
                    isAppInstalled = true;
                    break;
                }
            }
            if (!isAppInstalled) {
                filteredCommercialApps.push(app);
            }
        });

        this.commercialApps = filteredCommercialApps;
    }

    private getBaseCSSClass() {
        return ClassNames.SvgIconCssClass + ' ' + ClassNames.FluentIconCssClass;
    }
}
